import { memo, useEffect, useCallback, useState, FC, useContext } from "react";
import { SESSION_TIMEOUT, SESSION_GRACE } from "core/utils/constants";
import SessionTimeoutModal from "./sessionTimeoutModal";
import { removeListeners } from "./sessionTimeout.utils";
import { AuthContext } from "core/contexts/auth/auth";

const SessionTimeout: FC = (): JSX.Element => {
  const [showSessionModal, setShowSessionModal] = useState<boolean>(false);
  const { signOut } = useContext(AuthContext);
  let logoutTimer;
  let warningTimer;

  const onTimeout = useCallback(() => {
    removeListeners(resetTimer);
    setShowSessionModal(true);
  }, []);

  const onTimedOut = useCallback(() => {
    onLogout()
  }, []);

  const startTimer = () => {
    warningTimer = setTimeout(onTimeout, SESSION_TIMEOUT - SESSION_GRACE);
    logoutTimer = setTimeout(onTimedOut, SESSION_TIMEOUT);
  };

  const resetTimer = useCallback(() => {
    clearTimeout(logoutTimer);
    clearTimeout(warningTimer);
    startTimer();
  }, []);

  const extendTimer = useCallback(() => {
    resetTimer();
  }, []);

  useEffect(() => {
    extendTimer();
  }, []);

  const onLogout = (): void => {
    setShowSessionModal(false);
    signOut();
  };

  const onSessionExtendAndCloseTimeout = (): void => {
    extendTimer();
    setShowSessionModal(false);
  };

  return (
    <>
      {showSessionModal && (
        <SessionTimeoutModal
          showSessionTimeoutModal={showSessionModal}
          onExtendButtonClick={onSessionExtendAndCloseTimeout}
          onLogout={onLogout}
        />
      )}
    </>
  );
};
export default memo(SessionTimeout);
